export enum EloRank {
  BEGINNER = "BEGINNER",
  POKEBALL = "POKEBALL",
  GREATBALL = "GREATBALL",
  ULTRABALL = "ULTRABALL",
  MASTERBALL = "MASTERBALL"
}
